import { ROVASYS } from './companyConstants';

interface WatermarkOverlayProps {
    isVisible?: boolean;
}

export const WatermarkOverlay = ({ isVisible = true }: WatermarkOverlayProps) => {
    if (!isVisible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.05,
        }}>
            <img src={ROVASYS.logoPath} alt="" style={{ width: 450, height: 'auto' }} />
        </div>
    );
};
